export const isAnyApprovalCode = function (code) {
    return isApprovedCode(code) || isAnyPreapprovalCode(code)
}

export const isAnyPreapprovalCode = function (code) {
    return isPrequalifiedCode(code) || isPreapprovedCode(code)
}

export const isApprovedCode = function (code) {
    return code === ApplyResponseCode.APPROVED
}

export const isDeclinedCode = function (code) {
    return code === ApplyResponseCode.DECLINED
}

export const isErrorCode = function (code) {
    return code === ApplyResponseCode.ERROR
}

export const isNoOfferCode = function (code) {
    return code === ApplyResponseCode.NOOFFER
}

export const isPendingCode = function (code) {
    return code === ApplyResponseCode.PENDING
}

export const isPreapprovedCode = function (code) {
    return code === ApplyResponseCode.PREAPPROVED
}

export const isPrequalifiedCode = function (code) {
    return code === ApplyResponseCode.PREQUALIFIED
}

const ApplyResponseCode = {
    APPROVED: "approved",
    DECLINED: "declined",
    ERROR: "error",
    NOOFFER: "nooffer",
    PENDING: "pending",
    PREAPPROVED: "preapproved",
    PREQUALIFIED: "prequalified",
}

export default ApplyResponseCode
